var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "box view-nav-bar" }, [
      _c("div", { staticClass: "d-flex align-items-center w-100" }, [
        _c(
          "div",
          { staticClass: "flex-grow-1" },
          [
            _c(
              "router-link",
              { staticClass: "mr-3", attrs: { to: "/admissions/year" } },
              [
                _c("icon", { attrs: { name: "chevron-left" } }),
                _vm._v(" Back\n                "),
              ],
              1
            ),
            _vm._v(" "),
            _c("strong", [_vm._v(_vm._s(_vm.year))]),
            _vm._v(" "),
            _vm._m(0),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _vm.loading
      ? _c("div", { staticClass: "box" }, [
          _c(
            "div",
            { staticClass: "box-content text-center text-muted py-4" },
            [_vm._v("Loading…")]
          ),
        ])
      : !_vm.rows.length
      ? _c("div", { staticClass: "box" }, [
          _c(
            "div",
            { staticClass: "box-content text-center text-muted py-4" },
            [_vm._v("No admissions data found for " + _vm._s(_vm.year) + ".")]
          ),
        ])
      : _c("div", { staticClass: "box" }, [
          _c("div", { staticClass: "box-content" }, [
            _c("table", { staticClass: "shx-table w-100 mt-2" }, [
              _vm._m(1),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.rows, function (row) {
                  return _c("tr", { key: row.week_code }, [
                    _c(
                      "td",
                      [
                        _c(
                          "router-link",
                          {
                            attrs: {
                              to:
                                "/admissions/year/" +
                                _vm.year +
                                "/" +
                                row.week_code,
                            },
                          },
                          [
                            _vm._v(
                              "\n                                " +
                                _vm._s(row.week_code) +
                                "\n                            "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(row.week_start || "—"))]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(row.week_end || "—"))]),
                    _vm._v(" "),
                    _c("td", { staticClass: "text-right" }, [
                      _vm._v(_vm._s(_vm.formatInt(row.admissions))),
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "text-right" }, [
                      _vm._v(_vm._s(row.cinemas)),
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "text-right" }, [
                      _vm._v(_vm._s(row.titles)),
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "text-right" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            row.real_weighted !== null
                              ? row.real_weighted + "%"
                              : "—"
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      row.real_weighted !== null && row.real_weighted <= 90
                        ? _c(
                            "span",
                            {
                              staticClass: "badge badge-warning ml-1",
                              attrs: {
                                title: "Minimum real: " + row.real_min + "%",
                              },
                            },
                            [_vm._v("⚠")]
                          )
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c(
                      "td",
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "btn btn-sm btn-outline-secondary",
                            attrs: {
                              to:
                                "/admissions/year/" +
                                _vm.year +
                                "/" +
                                row.week_code,
                            },
                          },
                          [
                            _vm._v(
                              "\n                                Per Cinema\n                            "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ])
                }),
                0
              ),
              _vm._v(" "),
              _c("tfoot", [
                _c("tr", [
                  _vm._m(2),
                  _vm._v(" "),
                  _c("td", { staticClass: "text-right" }, [
                    _c("strong", [
                      _vm._v(_vm._s(_vm.formatInt(_vm.totalAdmissions))),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("td", { attrs: { colspan: "4" } }),
                ]),
              ]),
            ]),
          ]),
        ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "text-muted ml-2" }, [
      _vm._v("— Admissions per week, saleshouse "),
      _c("strong", [_vm._v("BF")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", { staticClass: "shx-th-100" }, [_vm._v("Week")]),
        _vm._v(" "),
        _c("th", { staticClass: "shx-th-120" }, [_vm._v("Start")]),
        _vm._v(" "),
        _c("th", { staticClass: "shx-th-120" }, [_vm._v("End")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right" }, [_vm._v("Admissions")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right shx-th-100" }, [
          _vm._v("# Cinemas"),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right shx-th-100" }, [
          _vm._v("# Titles"),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right shx-th-100" }, [_vm._v("Real %")]),
        _vm._v(" "),
        _c("th", { staticClass: "shx-th-120" }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", { attrs: { colspan: "3" } }, [
      _c("strong", [_vm._v("Total")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }